// @ts-nocheck
import "babel-polyfill";
import * as React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import AppRouter from "./routes";
const appDom = document.getElementById("app");
import reduxStore from './store';

const stack = (
    <Provider store={reduxStore}>
        <RouterProvider router={AppRouter} />
    </Provider>
);

const root = ReactDOM.createRoot(appDom);

root.render(stack);
